import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { EXPANDING_BUTTON__BUTTON_CLASS, EXPANDING_BUTTON__CONTAINER_CLASS } from '.';

const { spacing, text, fonts } = theme;

const TRANSITION = '400ms ease-in';

export const readMoreButtonText = css`
  z-index: 1;
  margin-left: ${pxToRem(spacing.xs)};
`;

export const expandingButtonContainer = css`
  &.${EXPANDING_BUTTON__CONTAINER_CLASS} {
  }
`;

export const expandingButton = css`
  &.${EXPANDING_BUTTON__BUTTON_CLASS} {
    background-color: ${colors.neutralWhite};
    &:before {
      position: absolute;
      content: '';

      pointer-events: none;
      top: -${pxToRem(text.sm.SMALL.lineHeight)};
      left: 0;
      width: 100%;
      height: ${pxToRem(text.sm.SMALL.lineHeight)};
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.3),
        ${colors.neutralWhite} 60%,
        ${colors.neutralWhite} 100%
      );
      transition: height ${TRANSITION};
      transition: opacity ${TRANSITION};
    }

    &[aria-expanded='true'] {
      padding: ${pxToRem(spacing.base)} 0;
      &:before {
        opacity: 0;
        height: 0;
      }
    }
  }
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: ${stack(spacing.base)};
  border: none;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveFontSize(text.xs)};
`;
